import baseUrl from "../config/baseUrl";

// Saves corrections (edited values / removed fields) made in the "Extracted
// Document Data" panel. Only ocr_data.ocr_full_data is updated.
const updateOcrFullData = async ({ token, documentId, pages }) => {
  try {
    const response = await fetch(`${baseUrl}/api/update-ocr-full-data`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ document_id: documentId, pages }),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export default updateOcrFullData;
